import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { fetchData } from '../api/publicService';
import {
  Box,
  Typography,
  CircularProgress,
  Alert,
  Container,
  Divider,
  Grid,
} from '@mui/material';
import styles from './BlogDetail.module.css'; // You'll need to create this CSS file

const BlogDetail = () => {
  const { id } = useParams();
  const { language } = useLanguage();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadPostDetails = async () => {
      window.scrollTo(0, 0);
      try {
        setLoading(true);
        const data = await fetchData(`/blogs/${id}`, language);
        setPost(data);
        setError(null);
      } catch (err) {
        setError('Could not find the requested blog post.');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
        loadPostDetails();
    }
  }, [id, language]);

  if (loading) {
    return <Box sx={{ display: 'flex', justifyContent: 'center', p: 10 }}><CircularProgress /></Box>;
  }

  if (error || !post) {
    return <Container sx={{py: 5}}><Alert severity="error">{error || 'Post not found.'}</Alert></Container>;
  }

  return (
    <Container maxWidth="md" sx={{py: 8}}>
      <Typography variant="h2" component="h1" sx={{ fontFamily: '"Playfair Display", serif', fontWeight: 700, mb: 2 }}>
        {post.title}
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{mb: 4}}>
        By {post.author}
      </Typography>
      <Box
        component="img"
        src={post.featuredImage}
        alt={post.title}
        sx={{ width: '100%', height: { xs: 300, md: 500 }, objectFit: 'cover', borderRadius: 2, mb: 4 }}
      />

      <div
        className={styles.contentContainer}
        dangerouslySetInnerHTML={{ __html: post.content }}
      />

      {post.additionalImages && post.additionalImages.length > 0 && (
        <Box sx={{ mt: 6 }}>
          <Divider sx={{ mb: 4 }} />
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Gallery
          </Typography>
          <Grid container spacing={2}>
            {post.additionalImages.map((image, index) => (
              <Grid item key={index} size={{ xs: 12, sm: 6, md: 4 }}>
                <Box
                  component="img"
                  src={image}
                  alt={`Gallery image ${index + 1}`}
                  sx={{ width: '100%', borderRadius: 1, boxShadow: 3 }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Container>
  );
};

export default BlogDetail;